import { useCallback, useState } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';
import { usePlayerEvent } from './usePlayerEvent';

export function usePlayerMute() {
  const player = usePlayer();
  const [isMuted, setIsMuted] = useState(player.getMute());

  const onChange = useCallback(() => {
    setIsMuted(player.getMute());
  }, [player]);

  usePlayerEvent('mute volume', onChange);

  const toggleMute = useCallback(() => {
    player.setMute(!isMuted);
  }, [player, isMuted]);

  return { isMuted, toggleMute };
}
